module.exports = __webpack_public_path__ + "media/music/piano_9-45d1621f.mp3";